import ValueNode from '../../ValueNode';
import Type from '../../../Type';
import config from '../../../utils/config';

import type Context from 'src/Context';
import type { BaseExpression, ParentContext, Expression } from 'src/types';

export interface EqualsNodeT extends BaseExpression {
    $type: 'EqualsNode';
    value: [Expression, Expression];
}

export default class EqualsNode extends ValueNode<EqualsNodeT> {
    static TYPE = Type.NTuple(
        { key: 'a', type: 'ValueNode', suggestions: 'primitive' },
        { key: 'b', type: 'ValueNode', suggestions: 'primitive' },
    );

    static uiConfig = {
        ...config.presets.comparison,
    };

    async execute(context: Context, { sourcePath }: ParentContext): Promise<any> {
        const source = await context.evaluate(this.expression.value[0], { sourcePath });
        const target = await context.evaluate(this.expression.value[1], { sourcePath });
        return source === target;
    }
}
